/**
 * Global Utils and Constants
 */
import { format } from 'date-fns';
import { OverallPerformanceConstants } from '../pages/overallPerformance/constant/overallPerformanceConstant';
import { SUB_BRANCH_DASHBOARD } from './routes';

export const LIST_TABLE_HEADERS = [
  {
    Header: 'Headline',
    accessor: 'headline',
    id: '1',
  },
  {
    Header: 'Start Date',
    accessor: 'startDate',
    id: '2',
  },
  {
    Header: 'End Date',
    accessor: 'endDate',
    id: '3',
  },
  {
    Header: 'Publish Date',
    accessor: 'publishDate',
    id: '4',
  },
  {
    Header: 'Store',
    accessor: 'store',
    id: '5',
  },
  {
    Header: 'Status',
    accessor: 'status',
    id: '6',
  },
  {
    Header: 'Action',
    accessor: 'action',
    id: '7',
  },
];

export const channelAndAudienceHeaders = [
  {
    Header: () => <span style={{ width: '130px', display: 'inline-grid' }}>{'Channel'}</span>,
    accessor: 'channel',
    enableRowSpan: true,
  },
  {
    Header: () => <span style={{ width: '150px', display: 'inline-grid' }}>{'Audience'}</span>,
    accessor: 'audience',
  },
  {
    Header: () => <span style={{ width: '80px', display: 'inline-grid' }}>{'Total'}</span>,
    accessor: 'total',
  },
];

export const isLocalType = (type) => type === 1;

export const formatDateToMDY = (date) => {
  const propsDate = new Date(date);
  return format(propsDate, 'MM/dd/yyyy');
};

export const formatDateToYMD = (date) => {
  try {
    if (!date) return '';

    const propsDate = date instanceof Date ? date : new Date(date);

    if (isNaN(propsDate.getTime())) {
      return '';
    }

    return format(propsDate, 'yyyy-MM-dd');
  } catch (error) {
    console.warn('formatDateToYMD error:', error, 'for input:', date);
    return '';
  }
};

export const formatDateToDDMMYY = (date) => {
  try {
    if (!date) return '-';

    const propsDate = date instanceof Date ? date : new Date(date);

    if (isNaN(propsDate.getTime())) {
      return '-';
    }

    return format(propsDate, 'dd/MM/yy');
  } catch (error) {
    console.warn('formatDateToDDMMYY error:', error, 'for input:', date);
    return '-';
  }
};

export const checkIfDateCrossedToday = (date) => {
  const today = new Date().getTime();
  return today > new Date(date).getTime() ? true : false;
};

export function validateEmail(email = '') {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase()) ? true : 'Enter an valid email';
}

export const LOCAL_STORAGE_AUTH_NAME = 'AUTH_USER_DATA';

export const getPercentToRegionData = (key) => {
  switch (key) {
    case 'Spend':
      return 'spend_comp_to_region';
    case 'Opportunities Generated':
      return 'opps_comp_to_region';
    case 'Opportunities Generated To Plan':
      return 'opps_to_plan_region';
    case 'Opportunities Closed':
      return 'opps_closed_comp_to_region';
    case 'Sales':
      return 'sales_comp_to region';
    case 'Cost per Opportunity':
      return 'cpo_comp_to_region';
    case 'Return on Marketing Investment':
      return 'romi_comp_to_region';
    case 'Average Job Size':
      return 'avg_job_size_comp_to_region';
    case 'Close Rate':
      return 'close_rate_comp_to_region';
    case 'Cancellation Rate':
      return 'cancel_rate_comp_to_region';
    default:
      return 'cancel_rate_comp_to_region';
  }
};

export const getPercentToGaleAvgData = (key) => {
  switch (key) {
    case 'Spend':
      return 'spend_comp_to_gale_avg';
    case 'Opportunities Generated':
      return 'opps_comp_to_gale_avg';
    case 'Opportunities Generated To Plan':
      return 'opps_to_plan_gale_avg';
    case 'Opportunities Closed':
      return 'opps_closed_comp_gale_avg';
    case 'Sales':
      return 'sales_comp_to_gale_avg';
    case 'Cost per Opportunity':
      return 'cpo_comp_to_gale_avg';
    case 'Return on Marketing Investment':
      return 'romi_comp_to_gale_avg';
    case 'Average Job Size':
      return 'avg_job_size_comp_to_gale_avg';
    case 'Close Rate':
      return 'close_rate_comp_to_gale_avg';
    case 'Cancellation Rate':
      return 'cancel_rate_comp_to_gale_avg';
    default:
      return 'cancel_rate_comp_to_gale_avg';
  }
};

export const FormatLongNumber = (value) => {
  if (value === 0) {
    return 0;
  } else {
    // hundreds
    if (value <= 999) {
      return value;
    }
    // thousands
    else if (value >= 1000 && value <= 999999) {
      return `${(value / 1000).toFixed(1)}k`;
    }
    // millions
    else if (value >= 1000000 && value <= 999999999) {
      return `${(value / 1000000).toFixed(1)}m`;
    }
    // billions
    else if (value >= 1000000000 && value <= 999999999999) {
      return `${(value / 1000000000).toFixed(1)}b`;
    } else return value;
  }
};

export const FormatLongNumberWithCurrency = (value) => {
  if (value === 0) {
    return 0;
  } else {
    // hundreds
    if (value <= 999) {
      const hasDecimal = value % 1 !== 0;
      if (hasDecimal) {
        value = parseFloat(value.toFixed(1));
      }
      return `$${value}`;
    }
    // thousands
    else if (value >= 1000 && value <= 999999) {
      return `$${(value / 1000).toFixed(1)}k`;
    }
    // millions
    else if (value >= 1000000 && value <= 999999999) {
      return `$${(value / 1000000).toFixed(1)}m`;
    }
    // billions
    else if (value >= 1000000000 && value <= 999999999999) {
      return `$${(value / 1000000000).toFixed(1)}b`;
    } else return value;
  }
};

export const fiscalMonths = {
  1: 'Dec',
  2: 'Jan',
  3: 'Feb',
  4: 'Mar',
  5: 'Apr',
  6: 'May',
  7: 'Jun',
  8: 'Jul',
  9: 'Aug',
  10: 'Sep',
  11: 'Oct',
  12: 'Nov',
};

export function toTitleCase(str) {
  return str
    .toLowerCase()
    .split(' ')
    .map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
}

function sortObj(obj) {
  return Object.keys(obj)
    .sort((a, b) => a.localeCompare(b))
    .reduce(function (result, key) {
      result[key] = obj[key];
      return result;
    }, {});
}

export function transformHeaders(data, store, key) {
  const dataHeaders = data?.[key]?.result;
  let headerIndex = 1;
  let headerNameArr = [];
  const filteredData = dataHeaders?.filter((data) => data.store_id === store);
  if (!filteredData.length) return [];
  filteredData
    .sort((a, b) => a.fiscal_month - b.fiscal_month)
    .filter(
      (eachHeader) => eachHeader.fiscal_month !== null && eachHeader.fiscal_month !== undefined
    )
    .forEach((eachHeader) => {
      for (let i = 1; i <= eachHeader.total_weeks; i++) {
        headerNameArr.push({
          Header: `${fiscalMonths[eachHeader.fiscal_month]} W${headerIndex}`,
          accessor: `${fiscalMonths[eachHeader.fiscal_month]}_W${headerIndex}`,
        });
        headerIndex++;
      }
    });
  return headerNameArr;
}

export const { CURRENCY = 'USD' } = process.env;

const getLang = (curr) => {
  switch (curr) {
    case 'INR': {
      return 'en-In';
    }

    default: {
      return 'en-Us';
    }
  }
};
export const CurrencyFormatter = (val = 0, showDecimals) => {
  return Intl.NumberFormat(getLang(CURRENCY), {
    style: 'currency',
    currency: CURRENCY,
    minimumFractionDigits: showDecimals ? 2 : 0,
  }).format(val);
};

export const formatNumber = (num = 0) => {
  return new Intl.NumberFormat('en-US').format(num);
};

export const unitSymbolFn = (unitLabel, value, showDecimals, decimalPoints, format) => {
  switch (unitLabel) {
    case 'NUMBER':
      if (value === null) {
        return '-';
      }
      return format ? formatNumber(value) : value;
    case 'PERCENTAGE':
      return `${value ? parseFloat(value).toFixed(decimalPoints || 2) : '0.00'}%`;
    case 'CURRENCY':
      return value !== null ? `${CurrencyFormatter(value, showDecimals)}` : '-';
    case 'OTHERS':
      return `${value}x`;
    default:
      return value;
  }
};

export function transformData(data, storeId, key, DATA_KEY = 'spend') {
  let rowData = {};
  const grandTotals = {};
  let grandTotalOverall = 0;
  const filteredData = data?.[key]?.result?.filter((data) => data.store_id === storeId);
  if (!filteredData.length) return [];
  const sortedData = filteredData?.slice().sort((a, b) => {
    const weekDiff = a.fiscal_week - b.fiscal_week;
    if (weekDiff !== 0) {
      return weekDiff;
    }
    return a.fiscal_month - b.fiscal_month;
  });
  sortedData.forEach((inputObject) => {
    if (!inputObject.channel || !inputObject.audience) {
      return;
    }
    const monthName = fiscalMonths[inputObject.fiscal_month];
    const key = `${monthName}_W${inputObject.fiscal_week}`;
    const spendFormatted =
      inputObject?.[DATA_KEY] !== null ? parseFloat(inputObject?.[DATA_KEY]?.toFixed(2)) : 0;
    const rowIdentifier = `${inputObject.channel}-${inputObject.audience}`;
    let existingRow = rowData[rowIdentifier];

    if (!existingRow) {
      existingRow = {
        channel: inputObject.channel,
        audience: inputObject.audience,
        total: 0,
      };
      rowData[rowIdentifier] = existingRow;
    }

    if (!existingRow[key]) {
      existingRow[key] = 0;
    }

    existingRow[key] += spendFormatted;
    existingRow.total += inputObject.spend !== null ? spendFormatted : 0;

    if (!grandTotals[key]) {
      grandTotals[key] = 0;
    }

    grandTotals[key] += inputObject.spend !== null ? spendFormatted : 0;
    grandTotalOverall += inputObject.spend !== null ? spendFormatted : 0;
  });

  const grandTotalOverallFormatted = grandTotalOverall;

  const grandTotalObject = {
    channel: '',
    audience: 'Grand Total',
    ...grandTotals,
    total: grandTotalOverallFormatted,
  };
  rowData = sortObj(rowData);
  rowData['GrandTotal'] = grandTotalObject;

  const formattedRowData = Object.values(rowData).map((row) => {
    const formattedRow = { ...row };
    for (const key in formattedRow) {
      if (key.includes('_W')) {
        let formattedValue = 0;
        if (formattedRow[key] !== null) {
          const unitLabel = DATA_KEY === 'spend' ? 'CURRENCY' : '';
          formattedValue = unitSymbolFn(unitLabel, formattedRow[key], true);
        }
        formattedRow[key] = formattedValue;
      }
    }
    formattedRow.total = unitSymbolFn(
      DATA_KEY === 'spend' ? 'CURRENCY' : '',
      formattedRow.total,
      true
    );
    return formattedRow;
  });
  const originalObject = formattedRowData[formattedRowData.length - 1];

  const transformedObject = {};
  for (const key in originalObject) {
    if (originalObject.hasOwnProperty(key)) {
      const value = originalObject[key];
      transformedObject[key] = `<span style="font-weight:700">${value}</span>`;
    }
  }
  formattedRowData[formattedRowData.length - 1] = transformedObject;
  return formattedRowData;
}

export const verifyRowData = (row, headers) => {
  let newRow = row;
  newRow?.forEach((eachRow) => {
    headers?.forEach((header) => {
      if (header.accessor && !eachRow.hasOwnProperty(header.accessor)) {
        eachRow[header.accessor] = '0';
      }
    });
  });
  return row;
};

export const verifySpendAndOppsRow = (row, headers) => {
  let newRow = row;
  if (headers?.length) {
    headers?.forEach((header) => {
      if (
        header.accessor !== 'Weekly_Opps_Seasonality' &&
        header.accessor !== 'Weekly_Spends_Seasonality' &&
        !newRow.hasOwnProperty(header.accessor)
      ) {
        newRow[header.accessor] = 'N/A';
      }
    });
    return newRow;
  }
};

export const transformMonthlyData = (data, store, key, DATA_KEY = 'spend') => {
  let rowData = {};
  const grandTotals = {};
  let grandTotalOverall = 0;
  const tableHeadersSet = new Set();
  const filteredData = data?.[key]?.result?.filter((data) => data.store_id === store);
  if (!filteredData.length)
    return {
      formattedRowData: [],
      tableHeaders: [],
    };

  const sortedData = filteredData.slice().sort((a, b) => {
    return a.fiscal_month - b.fiscal_month;
  });

  sortedData.forEach((inputObject) => {
    const monthName = fiscalMonths[inputObject.fiscal_month];
    const spendFormatted =
      inputObject?.[DATA_KEY] !== null ? parseFloat(inputObject?.[DATA_KEY]?.toFixed(1)) : 0;
    const rowIdentifier = `${inputObject.channel}-${inputObject.audience}`;

    if (!inputObject.channel || !inputObject.audience) {
      return;
    }

    let existingRow = rowData[rowIdentifier];

    if (!existingRow) {
      existingRow = {
        channel: inputObject.channel,
        audience: inputObject.audience,
        total: 0,
      };
      rowData[rowIdentifier] = existingRow;
    }

    if (inputObject.fiscal_month !== null && monthName !== undefined) {
      if (!existingRow[monthName]) {
        existingRow[monthName] = 0;
      }
      existingRow[monthName] += spendFormatted;

      tableHeadersSet.add(monthName);

      if (!grandTotals[monthName]) {
        grandTotals[monthName] = 0;
      }
      grandTotals[monthName] += spendFormatted;
    }
    existingRow.total += spendFormatted;
    grandTotalOverall += inputObject?.[DATA_KEY] !== null ? inputObject?.[DATA_KEY] : 0;
  });

  const grandTotalOverallFormatted = grandTotalOverall;

  const grandTotalObject = {
    channel: '',
    audience: 'Grand Total',
    ...grandTotals,
    total: grandTotalOverallFormatted,
  };
  rowData = sortObj(rowData);
  rowData['GrandTotal'] = grandTotalObject;

  const formattedRowData = Object.values(rowData).map((row) => {
    const formattedRow = { ...row };
    for (const key in formattedRow) {
      if (Object.values(fiscalMonths).includes(key)) {
        let formattedValue = 0;
        if (formattedRow[key] !== null) {
          const unitLabel = DATA_KEY === 'spend' ? 'CURRENCY' : '';
          formattedValue = unitSymbolFn(unitLabel, formattedRow[key], true);
        }
        formattedRow[key] = formattedValue;
      }
    }
    formattedRow.total = unitSymbolFn(
      DATA_KEY === 'spend' ? 'CURRENCY' : '',
      formattedRow.total,
      true
    );
    return formattedRow;
  });

  const tableHeaders = Array.from(tableHeadersSet).map((header) => ({
    Header: header,
    accessor: header,
  }));
  const originalObject = formattedRowData[formattedRowData.length - 1];

  const transformedObject = {};
  for (const key in originalObject) {
    if (originalObject.hasOwnProperty(key)) {
      const value = originalObject[key];
      transformedObject[key] = `<span style="font-weight:700">${value}</span>`;
    }
  }
  formattedRowData[formattedRowData.length - 1] = transformedObject;
  return { formattedRowData, tableHeaders };
};

export function generateHeadline(data, selectedConjunction = '', flipValue = false) {
  if (data === undefined || data === null || Object.keys(data).length === 0)
    return '[Please Select an HEADLINE]';
  if (typeof data?.FINANCE === 'string') {
    data.FINANCE = [data.FINANCE];
  }
  const { DISCOUNT = '', FINANCE = [], SWEETENER = '' } = data;
  const hasDiscount = DISCOUNT.length > 0;
  const hasSweetener = SWEETENER.length > 0;
  const hasFinance = FINANCE?.length > 0;
  const hasTwoFinances = FINANCE.length > 1;
  if (!hasDiscount && !hasFinance) return '[Please Select an HEADLINE]';
  const conjunction = (hasDiscount && hasFinance) || hasTwoFinances ? selectedConjunction : '';
  let sweetnerText = '';
  if (hasSweetener) {
    sweetnerText = (hasDiscount && hasFinance) || hasTwoFinances ? `${SWEETENER}` : `${SWEETENER}`;
  }
  let sweetenerText = '';
  if (hasSweetener) {
    if (sweetnerText.length > 0) {
      if (sweetnerText.toLowerCase().includes('plus')) {
        sweetenerText = `${sweetnerText}`;
      } else {
        sweetenerText = `PLUS ${sweetnerText}`;
      }
    }
  }
  let parts = [];

  if (hasTwoFinances) {
    parts = flipValue ? [`${FINANCE[1]}`, `${FINANCE[0]}`] : [`${FINANCE[0]}`, `${FINANCE[1]}`];
  } else if (hasDiscount && hasFinance) {
    parts = flipValue ? [`${FINANCE[0]}`, `${DISCOUNT}`] : [`${DISCOUNT}`, `${FINANCE[0]}`];
  } else if (hasDiscount) {
    parts = [`${DISCOUNT}`];
  } else if (hasFinance) {
    parts = [`${FINANCE[0]}`];
  }
  const headlineParts = parts.filter((part) => part.length).join(` ${conjunction} `);
  const headline = `${headlineParts} ${sweetenerText}`.trim();
  if (headline === ' ' || headline.length === 0) return '[Please Select an HEADLINE]';
  return headline;
}

// added this function to format the current plan spend and actual plan spend grant total when filters applied other than all channels
export const formateGrandTotalColumnsData = (data = []) => {
  const formatedData = {};
  data?.forEach((objData) => {
    Object.keys(objData)?.forEach((dtKey) => {
      if (!['channel', 'audience'].includes(dtKey)) {
        const value = objData[dtKey];
        let formNum = 0;

        // Handle different value types
        if (typeof value === 'number') {
          formNum = value;
        } else if (typeof value === 'string') {
          formNum = parseFloat(value.replace(/[^\d.-]/g, ''));
        }

        // Only add valid numbers
        if (!isNaN(formNum)) {
          if (formatedData[dtKey]) {
            formatedData[dtKey] = formNum + formatedData[dtKey];
          } else {
            formatedData[dtKey] = formNum;
          }
        }
      }
    });
  });

  Object.keys(formatedData).forEach((key) => {
    const afterCurrencyFormated = unitSymbolFn('CURRENCY', formatedData[key], true);
    formatedData[key] = `<span style="font-weight:700">${afterCurrencyFormated}</span>`;
  });

  const defaults = {
    channel: '',
    audience: `<span style="font-weight:700">Grand Total</span>`,
  };

  return {
    ...defaults,
    ...formatedData,
  };
};

export const currentYearAndQuarterFun = (
  transformedDataWithDate,
  previousWeekExtractor,
  WEEK_SUBSTRACTION_VALUE,
  TransformDate
) => {
  const startingWeekData = previousWeekExtractor(transformedDataWithDate, WEEK_SUBSTRACTION_VALUE);
  const currentYearBasedOnWeek = startingWeekData?.currentYear;
  const currentQuarterValue = TransformDate.getCurrentQuarterBasedOnWeek(
    `w${startingWeekData?.subtractedWeekValue}`,
    transformedDataWithDate[0]
  );
  return {
    currentYearBasedOnWeek: currentYearBasedOnWeek,
    currentQuarterValue: currentQuarterValue,
  };
};

export const PDFNames = {
  performanceOverview: 'PerformanceOverview.pdf',
  oppsInsights: 'OppsInsights.pdf',
};

export const refreshDateFormatter = (date) =>
  new Date(date).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });

export const getExtras = (spendToggleState, channel_query = 'channel') => {
  return (
    !spendToggleState && {
      extras: {
        where: `(lower(${channel_query}) not like '%local%')`,
      },
    }
  );
};

// added here as it is used in current plan and actual plan spend tab for 6 V2 API Calls
export const getPayload = (
  isAdmin,
  key,
  storeId,
  selectedYear,
  onlySendFilters,
  transformedDataWithDate,
  previousWeekExtractor
) => {
  const commonFilters = [{ col: 'store_id', op: 'in', val: storeId }];
  if (selectedYear) {
    const currentWeekData =
      transformedDataWithDate && previousWeekExtractor?.(transformedDataWithDate);
    selectedYear === currentWeekData?.currentYear &&
      commonFilters?.push({ col: 'dateindex', op: '<=', val: currentWeekData?.filter });
    commonFilters?.push({ col: 'fiscal_year', op: '==', val: selectedYear });
  }
  const filters = isAdmin
    ? commonFilters
    : [...commonFilters, { col: 'total_spend', op: '!=', val: '0' }];

  return onlySendFilters ? filters : { [key]: { filters } };
};

// modified tabs to be shown for the admin and branch owner. Pass adminCond, originalTab
export const modifyTabs = (isAdmin, tabsArray = []) => {
  if (isAdmin) {
    return tabsArray;
  }
  // if branch owner, remove the tab with displayAdminOnly true
  return tabsArray?.filter((tab) => tab?.displayAdminOnly !== true);
};

export const getAppliedFiltersPayload = (key, appliedFilters) => {
  const payload = {
    [key]: {
      filters: appliedFilters,
    },
  };
  return payload;
};

// function to set the errors to false for actual and current plan spend tabs, send serErros state as argument
export const setErrorsFunction = (setErrors) => {
  setErrors((prevErrors) => ({
    ...prevErrors,
    weekly_data_error: false,
    monthly_data_error: false,
  }));
};

export const LOCAL_BRANCH_SPEND = 'Local Branch';

export const getChannelAndAudienceHeaders = (spendToggleState) => {
  const headers = [
    {
      Header: () => <span style={{ width: '130px', display: 'inline-block' }}>{'Channel'}</span>,
      accessor: 'channel',
      enableRowSpan: true,
    },
    {
      Header: () => <span style={{ width: '80px', display: 'inline-block' }}>{'Total'}</span>,
      accessor: 'total',
    },
  ];

  if (!spendToggleState) {
    headers.splice(1, 0, {
      Header: () => <span style={{ width: '150px', display: 'inline-block' }}>{'Audience'}</span>,
      accessor: 'audience',
    });
  }

  return headers;
};

export const isStoreValid = (storeId, options, isMultiSelect = false) => {
  if (!storeId || !options || options.length === 0) {
    return false;
  }

  if (isMultiSelect) {
    // For multi-select, storeId is an array of store IDs
    if (!Array.isArray(storeId) || storeId?.length === 0) {
      return false;
    }
    return storeId.every((id) => {
      const store = options?.find((option) => option?.branch_number === id);
      return store && store?.enable_local_branch === true;
    });
  } else {
    // For single-select, storeId is a single store ID
    const store = options?.find((option) => option?.branch_number === storeId);
    return store ? store?.enable_local_branch === true : false;
  }
};

export const getRegionQueryKey = (spendToggleState) => {
  if (spendToggleState) {
    return OverallPerformanceConstants.OVERALL_PERFORMANCE_REGION_QUERY_LOCAL_SPEND_COMBINED;
  } else {
    return OverallPerformanceConstants.OVERALL_PERFORMANCE_REGION_QUERY_BRANCH_COMBINED;
  }
};

export const checkAndUpdateStoreId = (storeId, prevStoreId) => {
  if (storeId?.length === 1 && storeId?.[0] === 1) {
    return storeId; // If the array has only one element and it is 1, return the array as is
  } else if (
    storeId?.length > 0 &&
    storeId?.includes(1) &&
    prevStoreId?.length > 0 &&
    !prevStoreId?.includes(1)
  ) {
    return [1];
  }
  return storeId?.filter((id) => id !== 1); // Otherwise, remove 1 from the array
};

export const getFilteredStoreIds = (storeId, options) => {
  return storeId?.filter((id) => options?.some((option) => option?.branch_number === id));
};

export const getFirstSortedValueByRegion = (regionMapping, options) => {
  if (!regionMapping || !options?.length) return [];
  const [targetRegionId] =
    Object.entries(regionMapping).sort((a, b) => a[1].localeCompare(b[1]))?.[0] || [];

  const filteredOptions = options
    .filter((opt) => opt.region == targetRegionId && opt.branch_name)
    .sort((a, b) => a.branch_name.localeCompare(b.branch_name));

  return filteredOptions.length ? [filteredOptions[0].value] : [];
};
export const getSettingValue = (settings, key) => {
  const setting = settings?.find((obj) => obj?.key === key);
  if (!setting) return false;

  const value = setting.value;
  if (value === 'true') return true;
  if (value === 'false') return false;
  return value ?? false;
};

export const ACTUAL_SPEND_YEAR_FILTER = 'actual_spend_year_filter';
export const ENABLE_LOCAL_SPEND = 'enable_local_spend';

export const transformMenuData = (menuData) => {
  return menuData?.map((menu) => {
    if (menu.sub_menu?.length > 0) {
      return {
        header: menu.name,
        menuItems: menu.sub_menu.map((sub) => ({
          label: sub.name,
          to: sub.url,
          sub_menu: sub.sub_menu.length ? transformMenuData(sub.sub_menu) : [],
        })),
      };
    }
    return { header: menu.name, to: menu.url };
  });
};

export const expandDefaultMenu = (menu, pathname) => {
  if (menu?.menuItems?.length) {
    return menu?.menuItems?.some((item) => item?.to === pathname);
  }
  return false;
};

export const isRouteInMenu = (menu, route) => {
  if (!Array.isArray(menu)) {
    return false;
  }
  for (const item of menu) {
    if (item?.url && route?.includes(item?.url)) {
      return true;
    }
    if (item?.sub_menu && isRouteInMenu(item?.sub_menu, route)) {
      return true;
    }
  }
  return false;
};

export const findFirstValidUrl = (menu) => {
  if (!Array.isArray(menu)) {
    return null;
  }

  for (const item of menu) {
    if (item?.url) {
      return item?.url;
    }
    if (item?.sub_menu) {
      const subMenuUrl = findFirstValidUrl(item?.sub_menu);
      if (subMenuUrl) {
        return subMenuUrl;
      }
    }
  }
  return null;
};

export const LocalBranchToogleHelperNoteOBJ = {
  semOppsTable: 'Local Spend Toggle not applicable for SEM Opps',
  romiTable: 'Local Spend Toggle not applicable for YTD Performance ROMI',
  cpoTable: 'Local Spend Toggle not applicable for YTD Performance CPO',
};

export const appendChannelFilter = (baseFilters, selectedChannels, defaultSelectedChannels) => {
  const fallbackChannels = Array.isArray(defaultSelectedChannels)
    ? defaultSelectedChannels?.map((channel) => channel?.value)?.filter(Boolean)
    : [];

  const channelFilter = {
    col: 'channel',
    op: 'IN',
    val:
      Array.isArray(selectedChannels) && selectedChannels.length > 0
        ? selectedChannels
        : fallbackChannels,
  };

  return Array.isArray(baseFilters) ? [...baseFilters, channelFilter] : baseFilters;
};

/**
 * Formats and sorts the store list for dropdown display
 * Places Gale Markets (store ID 1) at the top if present
 * and sorts remaining stores alphabetically by name
 */
export const formatStoreOptions = (userStores) => {
  if (!userStores?.length) return [];

  const stores = userStores.map((store) => ({
    label: store.branch_name,
    value: store.branch_number,
    ...store,
  }));

  const GaleMarkets = stores.filter((store) => store.value === 1);

  if (GaleMarkets.length) {
    return [
      GaleMarkets[0],
      ...stores.filter((store) => store.value !== 1).sort((a, b) => a.label.localeCompare(b.label)),
    ];
  } else {
    return [
      ...stores.filter((store) => store.value !== 1).sort((a, b) => a.label.localeCompare(b.label)),
    ];
  }
};

export const stableObject = (obj) => JSON.stringify(obj);

export const formatRegionOptions = (regions, isGaleAdmin) => {
  const regionNames = regions.map((region) => ({
    label: region.name,
    value: region.id,
    ...region,
  }));
  regionNames.sort((a, b) => a.label.localeCompare(b.label));

  if (isGaleAdmin) {
    regionNames.unshift({ label: 'None', value: '' });
  }

  return [...regionNames];
};

export const removeFiltersByKeys = (filters, keysToRemove) => {
  if (!Array.isArray(filters)) {
    console.error('Filters must be an array');
    return [];
  }

  if (!Array.isArray(keysToRemove) || keysToRemove.length === 0) {
    return [...filters];
  }

  return filters?.filter((filter) => {
    // Keep the filter only if its column name is NOT in the keysToRemove array
    return !keysToRemove.includes(filter.col);
  });
};

export const getFilteredStoreOptions = (userStores, userData, subBranchDashboard, currentUrl) => {
  // First, map the stores to create the options format
  const stores = userStores.map((store) => ({
    label: store.branch_name,
    value: store.branch_number,
    ...store,
  }));

  // If not in sub-branch dashboard, return standard options
  if (!subBranchDashboard) {
    const GaleMarkets = stores.filter((store) => store.value === 1);
    if (GaleMarkets?.length) {
      return [
        GaleMarkets[0],
        ...stores
          .filter((store) => store.value !== 1)
          .sort((a, b) => a.label.localeCompare(b.label)),
      ];
    } else {
      return [
        ...stores
          .filter((store) => store.value !== 1)
          .sort((a, b) => a.label.localeCompare(b.label)),
      ];
    }
  }

  // Find the sub-branch dashboard menu item
  const subBranchMenu = userData?.menu?.find(
    (item) => item.name === 'Sub Branch Dashboard' || item.url === SUB_BRANCH_DASHBOARD
  );

  if (!subBranchMenu) {
    // Return standard options if sub-branch menu not found
    const GaleMarkets = stores.filter((store) => store.value === 1);
    if (GaleMarkets?.length) {
      return [
        GaleMarkets[0],
        ...stores
          .filter((store) => store.value !== 1)
          .sort((a, b) => a.label.localeCompare(b.label)),
      ];
    } else {
      return [
        ...stores
          .filter((store) => store.value !== 1)
          .sort((a, b) => a.label.localeCompare(b.label)),
      ];
    }
  }

  // Find the specific sub-menu item matching the current URL
  const subMenuItem = subBranchMenu.sub_menu?.find(
    (subItem) => subItem.url === currentUrl || currentUrl.includes(subItem.url)
  );

  if (!subMenuItem?.store_ids?.length) {
    return [];
  }

  // Filter stores based on the store_ids from the sub-menu item
  const filteredStores = stores.filter((store) => subMenuItem.store_ids.includes(store.value));

  // Return filtered stores with the same sorting logic
  const GaleMarkets = filteredStores.filter((store) => store.value === 1);

  if (GaleMarkets?.length) {
    return [
      GaleMarkets[0],
      ...filteredStores
        .filter((store) => store.value !== 1)
        .sort((a, b) => a.label.localeCompare(b.label)),
    ];
  } else {
    return filteredStores
      .filter((store) => store.value !== 1)
      .sort((a, b) => a.label.localeCompare(b.label));
  }
};
